
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff87"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff87"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("bUxu8", function(module, exports) {
module.exports = new URL("dotlake-transparent-high-quality.04cb8c2b.png", import.meta.url).toString();

});

var $5c0150b831894da7$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["7trAT","treasuries.e5095442.js","5a0IP","dotlake-transparent-high-quality.04cb8c2b.png","kekbr","block_weights.1b4200d3.js","gC06X","block_weights.runtime.d84cf181.js","k2Svh","block_weights.e56a9c2e.js"]'));


var $2R6UY = parcelRequire("2R6UY");
parcelRequire("bUxu8");
"use strict";
var $fe7e530ee33ffb55$var$currentTheme = localStorage.getItem("theme") || "light";
var $fe7e530ee33ffb55$var$chartsConfig = $fe7e530ee33ffb55$var$update_chartsConfig($fe7e530ee33ffb55$var$currentTheme);
function $fe7e530ee33ffb55$var$update_chartsConfig(currentTheme) {
    $fe7e530ee33ffb55$var$chartsConfig = [
        {
            elementId: "treasury_monthly_polkadot_assets",
            jsonPath: "data/ecosystem_monthly_treasury_assets_polkadot000000000000.jsonl",
            relay: "polkadot",
            freq: "monthly",
            xName: "month",
            build: $2R6UY.treasury_assets
        },
        {
            elementId: "treasury_monthly_polkadot_assets_native",
            jsonPath: "data/ecosystem_monthly_treasury_assets_polkadot000000000000.jsonl",
            freq: "monthly",
            xName: "month",
            build: $2R6UY.treasury_assets_native
        },
        {
            elementId: "treasury_monthly_kusama",
            jsonPath: "data/ecosystem_monthly_treasury_relay_new000000000000.jsonl",
            relay: "kusama",
            freq: "monthly",
            xName: "month",
            build: $2R6UY.treasuries
        }
    ];
    $fe7e530ee33ffb55$var$chartsConfig.forEach((config)=>{
        const chart = $2R6UY.createEchartElement(config.elementId, currentTheme);
        if (chart) $2R6UY.loadJSONData(config.jsonPath, config.relay, (data)=>{
            config.build(config, data, chart); // Pass chart instance to build function
        }, chart);
        else console.error(`Failed to create chart for element ${config.elementId}`);
    });
}
// Listen for DOM content loaded to initialize the chart and setup theme switching
document.addEventListener("DOMContentLoaded", ()=>{
    const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
    toggleSwitch.addEventListener("change", (e)=>{
        $fe7e530ee33ffb55$var$currentTheme = e.target.checked ? "dark" : "light";
        localStorage.setItem("theme", $fe7e530ee33ffb55$var$currentTheme);
        document.body.classList.toggle("dark-mode", $fe7e530ee33ffb55$var$currentTheme === "dark");
        $fe7e530ee33ffb55$var$update_chartsConfig($fe7e530ee33ffb55$var$currentTheme);
    });
    if (localStorage.getItem("theme") === "dark") {
        toggleSwitch.checked = true;
        document.body.classList.add("dark-mode");
    }
    $fe7e530ee33ffb55$var$update_chartsConfig($fe7e530ee33ffb55$var$currentTheme);
});


//# sourceMappingURL=treasuries.e5095442.js.map
